import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

const DEFAULT_MAX = 500;

// Confirmation dialog with a comment / reason (reject, send back, hold, void, cancel...).
// required (default true) -> confirm disabled until a non-blank value; at most `max`
// characters. The server re-checks both.
const CommentDialog = ({ open, title, message, label, confirmLabel, color, busy, onClose, onConfirm, required = true, max = DEFAULT_MAX }) => {
  const [value, setValue] = useState('');
  useEffect(() => { if (open) setValue(''); }, [open]);
  const trimmed = value.trim();
  const tooLong = trimmed.length > max;
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {message && <Alert severity={color === 'error' ? 'warning' : 'info'} sx={{ mb: 1 }}>{message}</Alert>}
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          margin="dense"
          label={label}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          error={tooLong}
          helperText={`${trimmed.length}/${max}${tooLong ? ' - too long' : ''}`}
          inputProps={{ 'aria-label': label }}
          required={required}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy} sx={{ textTransform: 'none' }}>Cancel</Button>
        <Button
          variant="contained"
          color={color}
          disabled={busy || (required && !trimmed) || tooLong}
          onClick={() => onConfirm(trimmed)}
          sx={{ textTransform: 'none' }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentDialog;
